import type { CSSProperties } from "react";

/** The "← Back" that returns a phone from a detail view to its list (see usePhoneDetail). */
export default function PhoneBackButton({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button type="button" onClick={onClick} style={style}>
      ← {label}
    </button>
  );
}

// 44px tall: the phone tap-target minimum Travis chose for Phase 4 (2026-10-09).
const style: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  minHeight: 44,
  padding: "0 14px",
  marginBottom: 12,
  background: "transparent",
  color: "var(--gold)",
  border: "1px solid var(--border)",
  borderRadius: 8,
  fontSize: 15,
  fontWeight: 700,
  cursor: "pointer",
};
